import LoadingSpinner from "@/components/common/pages/loading-spinner";
import NotFound from "@/components/common/pages/not-found";
import UserProfile from "@/components/common/user-profile";
import { appErrorPaths } from "@/lib/app-error-routes";
import { getProtectedRouteAuthDecision } from "@/lib/auth-status";
import { hasStoredUser } from "@/lib/auth-storage";
import {
  Link,
  Outlet,
  createFileRoute,
  redirect,
} from "@tanstack/react-router";

export const Route = createFileRoute("/_onboarding")({
  component: RouteComponent,
  beforeLoad: async ({ context, location }) => {
    const hadStoredUser = hasStoredUser();
    const authStatus = await context.auth.checkAuthentication();
    const decision = getProtectedRouteAuthDecision(authStatus, hadStoredUser);

    if (decision === "session-expired") {
      throw redirect({
        to: appErrorPaths["session-expired"],
        search: {
          from: location.href,
        },
      });
    }

    if (decision === "sign-in") {
      throw redirect({
        to: "/sign-in",
        search: {
          redirect: location.href,
        },
      });
    }
  },
  notFoundComponent: () => <NotFound />,
  pendingComponent: () => (
    <div className="flex h-screen items-center justify-center">
      <LoadingSpinner size={50} />
    </div>
  ),
  pendingMs: 25,
});

function RouteComponent() {
  return (
    <div className="relative flex min-h-screen flex-col">
      <div className="-translate-y-1/2 pointer-events-none absolute top-1/2 right-0 z-0">
        <img
          src="/onboarding/illustration_signup.svg"
          alt="Signup illustration"
          className="object-contain"
        />
      </div>
      <header className="relative z-10 flex h-16 shrink-0 items-center border-b">
        <div className="flex w-full items-center justify-between px-4">
          <Link to="/">
            <img
              className="h-fit w-32"
              src="/logo.png"
              alt="Openfarming"
              width={100}
              height={100}
            />
          </Link>
          <UserProfile />
        </div>
      </header>
      <main className="relative z-10 flex-1">
        <Outlet />
      </main>
    </div>
  );
}
